import moment from "moment";
class EmployeedCard {
  constructor(empId, empNombre, fecDesde, fecHasta) {
    this.empId = empId;
    this.empNombre = empNombre;
    this.fecDesde = moment(fecDesde, "YYYY-MM-DD").format("DD-MM-YYYY");
    this.fecHasta = fecHasta
      ? moment.utc(fecHasta, "YYYY-MM-DD").format("DD-MM-YYYY")
      : "";
  }

  static fromJson({ empId, empNombre, fecDesde, fecHasta }) {
    return new EmployeedCard(empId, empNombre, fecDesde, fecHasta);
  }
}

export default EmployeedCard;
